import React, { useState } from 'react';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import ListItemText from '@mui/material/ListItemText';
import Select from '@mui/material/Select';
import Checkbox from '@mui/material/Checkbox';
import Label from './Label';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import { Button, Dialog, DialogContent, DialogTitle } from '@mui/material';
import { Document, Page, pdfjs } from 'react-pdf';

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;

const MenuProps = {
	PaperProps: {
		style: {
			maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
			width: 250,
		},
	},
};

export const MultipleSelectCheckmarks = ({
	label,
	state,
	setState,
	areas,
	styleConfig = {},
	setWasModifiedVariables,
}) => {
	const handleChange = (event) => {
		setWasModifiedVariables(false);
		const {
			target: { value },
		} = event;
		setState(
			// On autofill we get a stringified value.
			typeof value === 'string' ? value?.split(',') : value
		);
	};

	return (
		<div style={styleConfig}>
			<FormControl sx={{ m: 1, width: '90%' }}>
				<InputLabel id='demo-multiple-checkbox-label'>
					{label}
				</InputLabel>
				<Select
					labelId='demo-multiple-checkbox-label'
					id='demo-multiple-checkbox'
					multiple
					value={state}
					onChange={handleChange}
					input={<OutlinedInput label={label} />}
					renderValue={(selected) => selected?.join(', ')}
					MenuProps={MenuProps}
				>
					{areas?.map((name) => (
						<MenuItem key={name} value={name}>
							<Checkbox checked={state?.indexOf(name) > -1} />
							<ListItemText primary={name} />
						</MenuItem>
					))}
				</Select>
			</FormControl>
		</div>
	);
};

// Icon component
export const Icon = ({ name, sidebar = true, color = null }) => (
	<i
		className={`bi bi-${name}`}
		style={
			sidebar
				? { marginRight: '10px', color }
				: { margin: '0 -7px', color }
		}
	/>
);

// Label colors demonstration
export const LabelColorsDemonstrations = () => (
	<>
		<Label color='default'>default</Label>
		<Label color='primary'>primary</Label>
		<Label color='secondary'>secondary</Label>
		<Label color='info'>info</Label>
		<Label color='success'>success</Label>
		<Label color='warning'>warning</Label>
		<Label color='error'>error</Label>
	</>
);

// Chip selector

const getStyles = (name, personName, theme) => ({
	fontWeight:
		personName.indexOf(name) === -1
			? theme.typography.fontWeightRegular
			: theme.typography.fontWeightMedium,
});

export const MultipleSelectChip = ({
	dataDB = [],
	personName,
	setPersonName,
}) => {
	const theme = useTheme();
	// const [personName, setPersonName] = React.useState([]);

	const handleChange = (event) => {
		const {
			target: { value },
		} = event;
		setPersonName(
			// On autofill we get a stringified value.
			typeof value === 'string' ? value.split(',') : value
		);
	};

	return (
		<div>
			<FormControl sx={{ m: 1, width: '100%' }}>
				<InputLabel id='demo-multiple-chip-label'>
					Contactos seleccionados
				</InputLabel>
				<Select
					labelId='demo-multiple-chip-label'
					id='demo-multiple-chip'
					multiple
					value={personName}
					onChange={handleChange}
					input={
						<OutlinedInput
							id='select-multiple-chip'
							label='Contactos seleccionados'
						/>
					}
					renderValue={(selected) => (
						<Box
							sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}
						>
							{selected.map((value) => (
								<Chip
									key={value}
									label={value}
									style={{ margin: '5px 0' }}
								/>
							))}
						</Box>
					)}
					MenuProps={MenuProps}
				>
					{dataDB.map((name) => (
						<MenuItem
							key={name}
							value={name}
							style={getStyles(name, personName, theme)}
						>
							{name}
						</MenuItem>
					))}
				</Select>
			</FormControl>
		</div>
	);
};

export const PreviewerPDF = (
	blob,
	filename,
	isOpenPDFViewer,
	handleClosePDFDialog
) => {
	// PDF viewer dialog
	const [numPages, setNumPages] = useState(null);
	const [scale, setScale] = useState(1.3); // State for zoom level

	// Handle num pages
	const onDocumentLoadSuccess = ({ numPages }) => {
		setNumPages(numPages);
	};
	// Handle download
	const handleDownload = () => {
		const url = URL.createObjectURL(blob);
		const a = document.createElement('a');
		a.href = url;
		a.download = `${filename}.pdf`;
		a.click();
	};
	// Zoom
	const handleZoomIn = () => setScale((prevScale) => prevScale + 0.1);
	const handleZoomOut = () => setScale((prevScale) => prevScale - 0.1);

	// Button style
	const ButtonStyle = { marginLeft: '15px' };

	return (
		<Dialog
			open={isOpenPDFViewer}
			onClose={handleClosePDFDialog}
			maxWidth='md'
			fullWidth
		>
			<DialogTitle>Visualizador de PDF</DialogTitle>
			<DialogContent>
				<div className='pdf-controls'>
					<Button style={ButtonStyle} onClick={handleZoomIn}>
						Acercar Zoom
					</Button>
					<Button style={ButtonStyle} onClick={handleZoomOut}>
						Alejar Zoom
					</Button>
					<Button
						color='success'
						onClick={handleDownload}
						style={ButtonStyle}
					>
						Descargar
					</Button>
					<Button
						color='error'
						onClick={handleClosePDFDialog}
						style={ButtonStyle}
					>
						Salir
					</Button>
				</div>

				{blob && (
					<Document file={blob} onLoadSuccess={onDocumentLoadSuccess}>
						{[...Array(numPages)].map((_, index) => (
							<Page
								key={`page_${index + 1}`}
								pageNumber={index + 1}
								scale={scale}
							/>
						))}
					</Document>
				)}
			</DialogContent>
		</Dialog>
	);
};
